/**
 * Relative-age formatting for the Quarantine-by-reason section (REQ-STATUS-100).
 *
 * Its own module so the section file exports only components — Fast Refresh
 * stops working otherwise, which `react-refresh/only-export-components` flags.
 * It earns the separation anyway: a pure string function is the part worth
 * testing without mounting anything.
 */
/**
 * Render a count's recency as a short relative phrase.
 *
 * Relative rather than absolute because the operator's question is "is this
 * still happening?", which an ISO timestamp makes them compute. The absolute
 * instant rides in `title` for the case where they need it.
 */
export function formatRecency(at: string, now: number): string {
  const then = Date.parse(at);
  if (Number.isNaN(then)) return "unknown";
  const seconds = Math.max(0, Math.round((now - then) / 1000));
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86_400)}d ago`;
}
